"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = exports.DrawerTitle = exports.DrawerFooter = exports.DrawerContent = exports.DrawerHeader = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
const DEFAULT_PADDING = '$3 $4';
exports.DrawerHeader = (0, flora_react_1.styled)(flora_react_1.Flex, {
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    padding: DEFAULT_PADDING,
    paddingBottom: '0',
});
exports.DrawerContent = (0, flora_react_1.styled)('div', {
    padding: DEFAULT_PADDING,
    flex: 1,
    overflowY: 'auto',
});
exports.DrawerFooter = (0, flora_react_1.styled)('div', {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    '@tablet': {
        transform: 'translateY(-56px)',
    },
});
exports.DrawerTitle = (0, flora_react_1.styled)(flora_react_1.Text, {
    color: '$nonInteractivePredominant',
    fontSize: '$2subtitleMobile',
    fontWeight: '$medium',
    lineHeight: '$short',
});
exports.CloseButton = (0, flora_react_1.styled)('span', {
    cursor: 'pointer',
});
